import React from "react";

import { Chip } from "@mui/material";
import mainStyles from "styles";

import { SubscriptionType } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { subscriptionTypeNameDisplayMapping } from "constants/index";

interface SubscriptionTypeChipProps {
  subscriptionType: SubscriptionType | undefined;
}

const SubscriptionTypeChip = ({
  subscriptionType,
}: SubscriptionTypeChipProps) => {
  const classes = mainStyles();

  if (subscriptionType === undefined) {
    return <></>;
  }

  const chipClass =
    subscriptionType == SubscriptionType.FREE_ORG
      ? classes.yellowSubmarine
      : classes.purpleRain;

  return (
    <Chip
      size="small"
      color="primary"
      sx={{ ...chipClass, fontWeight: "bold", marginBottom: "3px" }}
      label={subscriptionTypeNameDisplayMapping[subscriptionType]}
      data-testid="subscription-type-chip"
    />
  );
};

export default SubscriptionTypeChip;
